export type HistoryKind = 'ask' | 'when' | 'check' | 'lucky';

/** Cache scope only; the API verifies authentication and ownership on every request. */
export function toolHistoryUserId(jwt: string | null): string | null {
  try {
    const parts = jwt?.split('.');
    if (parts?.length !== 3 || parts.some(part => !/^[A-Za-z0-9_-]+$/.test(part))) return null;
    const encoded = parts[1]!.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')), char => char.charCodeAt(0));
    const payload: unknown = JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes));
    if (typeof payload !== 'object' || payload === null || !('userId' in payload)) return null;
    return typeof payload.userId === 'string' && payload.userId.trim().length > 0 && payload.userId.length <= 100 ? payload.userId : null;
  } catch { return null; }
}

export interface HistoryItem { id: string; createdAt: string; label: string }
export interface HistoryPage { items: HistoryItem[]; nextCursor: string | null }
export interface AskHistoryResult {
  id: string; createdAt: string; question: string; shortAnswer: string | null;
  fullAnswer: string | null; paidAt: string | null;
}
export interface WhenHistoryResult {
  id: string; createdAt: string; question: string; horizon: number;
  llmSummary: string | null;
  topDates: { date: string; score: number; driver: string | null }[];
  deepDiveTexts: Record<string, string>;
  freeDiveUsed: boolean; detailUnlocked: boolean;
  freeDiveUsedAt: string | null; detailUnlockedAt: string | null;
  paidHorizon: number | null; paidAt: string | null; paidRunId: string | null;
}

/** Keep graphemes (including skin tones and joined emoji) together in titles. */
export function historyFirstLine(label: string, max = 100): string {
  const line = label.split(/\r?\n/, 1)[0]?.trim() ?? '';
  const points = Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(line), part => part.segment);
  return points.length > max ? `${points.slice(0, max - 1).join('')}…` : points.join('');
}
